// function that checks if a string is a number
export const isNumeric = (str: string): boolean => {
  if (typeof str !== 'string') {
    return false;
  }
  return !Number.isNaN(parseInt(str, 10));
};

export const isSpecialBuildingNumber = (inputString: string): boolean => {
  // Regex: ^[a-zA-Z0-9]{4}$
  // ^ - begyndelsen af strengen
  // [a-zA-Z0-9] - et alfanumerisk tegn (bogstav eller tal)
  // {4} - præcis fire af disse tegn
  // $ - slutningen af strengen
  const regex = /^[a-zA-Z0-9]{4}$/;
  return regex.test(inputString);
};
